import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-question-mark',
  templateUrl: './question-mark.component.html',
  styleUrl: './question-mark.component.scss'
})
export class QuestionMarkComponent {
    @Input() tooltipText: string;
}
